import { Node, mergeAttributes } from '@tiptap/core';
import { ReactNodeViewRenderer } from '@tiptap/react';
import WarmUpDiscussionEmbed from '../components/Exercise/WarmUpDiscussionEmbed';

export default Node.create({
  name: 'warmUpDiscussionExercise',
  
  group: 'block',
  
  atom: true,
  draggable: true,
  
  addAttributes() {
    return {
      questions: {
        default: [],
        parseHTML: element => {
          const data = element.getAttribute('questions');
          if (data) {
            try {
              return JSON.parse(data);
            } catch (e) {
              console.error('Error parsing WarmUpDiscussion from HTML:', e);
              return [];
            }
          }
          return [];
        },
        renderHTML: attributes => {
          if (attributes.questions) {
            return {
              questions: JSON.stringify(attributes.questions)
            };
          }
          return {};
        }
      },
      title: {
        default: 'Warm-Up Discussion',
        parseHTML: element => element.getAttribute('title') || 'Warm-Up Discussion',
        renderHTML: attributes => {
          if (attributes.title) {
            return {
              title: attributes.title
            };
          }
          return {};
        }
      },
      level: {
        default: 'B1',
        parseHTML: element => element.getAttribute('level') || 'B1',
        renderHTML: attributes => {
          if (attributes.level) {
            return {
              level: attributes.level
            };
          }
          return {};
        }
      },
      exerciseId: {
        default: null,
        parseHTML: element => element.getAttribute('data-exercise-id') || null,
        renderHTML: attributes => attributes.exerciseId ? { 'data-exercise-id': attributes.exerciseId } : {}
      }
    };
  },
  
  parseHTML() {
    return [
      {
        tag: 'div[data-type="warm-up-discussion-exercise"]',
      },
    ];
  },
  
  renderHTML({ HTMLAttributes }) {
    return ['div', mergeAttributes(HTMLAttributes, { 'data-type': 'warm-up-discussion-exercise' })];
  },
  
  addNodeView() {
    return ReactNodeViewRenderer(WarmUpDiscussionEmbed);
  },
  
  addCommands() {
    return {
      insertWarmUpDiscussionExercise:
        (attributes = {}) =>
        ({ commands }) => {
          return commands.insertContent({
            type: this.name,
            attrs: attributes,
          });
        },
    };
  },
}); 